import { render, staticRenderFns } from "./ticketHistory.vue?vue&type=template&id=409ec836&"
import script from "./ticketHistory.vue?vue&type=script&lang=js&"
export * from "./ticketHistory.vue?vue&type=script&lang=js&"
import style0 from "./ticketHistory.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports